/**
 * PDF Report Elements Index
 * 
 * This file exports all PDF rendering components for the report document generation.
 * These components are used by @react-pdf/renderer to create PDF exports.
 */

// PDF Title Components
import { MuiHeaderSubTitle, MuiTitle, MuiSubTitle } from './Titles';

// PDF Field Components  
import { MuiStringField, MuiLinkField, MuiValueField } from './Fields';

// PDF Header Component
import MuiHeader from './Header';

// PDF Table Component
import MuiTable from './Table';

// PDF Plot Component
import MuiPlot from './Plot';

// Floor Plan Elements (if used in PDFs)
import MuiCeiling from './MuiCeiling';
import MuiPartitions from './MuiPartitions';
import MuiLoadingDocks from './MuiLoadingDocks';
import MuiStorage from './MuiStorage';
import MuiDevices from './MuiDevices';
import MuiDoor from './MuiDoor';
import MuiFurniture from './MuiFurniture';

// Export individual components
export {
  // Title components
  MuiHeaderSubTitle,
  MuiTitle,
  MuiSubTitle,
  // Field components
  MuiStringField,
  MuiLinkField,
  MuiValueField,
  // Main components
  MuiHeader,
  MuiTable,
  MuiPlot,
  // Floor plan elements
  MuiCeiling,
  MuiPartitions,
  MuiLoadingDocks,
  MuiStorage,
  MuiDevices,
  MuiDoor,
  MuiFurniture,
};

// Default export for reportElements usage in ExportDocument.tsx
// Maps element names used in reportDocument.js to actual components
export default {
  // Title components - using the names expected by reportDocument.js
  headerSubTitle: MuiHeaderSubTitle,
  title: MuiTitle,
  subTitle: MuiSubTitle,
  
  // Field components
  stringField: MuiStringField,
  linkField: MuiLinkField,
  valueField: MuiValueField,
  
  // Main components
  header: MuiHeader,
  table: MuiTable,
  plot: MuiPlot,
  
  // Floor plan elements (if needed)
  MuiCeiling,
  MuiPartitions,
  MuiLoadingDocks,
  MuiStorage,
  MuiDevices,
  MuiDoor,
  MuiFurniture,
};